import { j as r } from "./kezios-design-system.esm172.js";
import { Container as i } from "@mantine/core";
import { Spacing as s } from "./kezios-design-system.esm135.js";
const p = ({ children: t, ...o }) => /* @__PURE__ */ r.jsx(i, { ...o, size: 1280, px: s.s4, style: { width: "100%" }, children: t });
export {
  p as SectionLayout
};
